import React from "react";

const RightSidebar = ({ property }) => {
  // Build embed URL from lat/lng (no API key required)
  const embedUrl =
    property.latitude && property.longitude
      ? `https://www.google.com/maps?q=${property.latitude},${property.longitude}&hl=es;z=14&output=embed`
      : "";

  return (
    <div className="overviewrtl">
      <div className="rtmap">
        {/* Google Maps Iframe */}
        {embedUrl && (
          <iframe
            src={embedUrl}
            width="100%"
            height="250"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            title="Property Location"
          ></iframe>
        )}

        {/* Link to full Google Maps */}
        <ul>
          <li>
            {property.address}
          </li>
          <li>
            <a
          href={`https://www.google.com/maps?q=${property.latitude},${property.longitude}`}
          target="_blank"
          rel="noopener noreferrer"
          className="viewlargemap"
        >
          View on larger map
        </a>
          </li>
          
        </ul>
        
      </div>
    </div>
  );
};

export default RightSidebar;
